<!--sidebar-->
@if (!isMobile) {
<c-sidebar
  #sidebar="cSidebar"
  class="d-print-none sidebar sidebar-fixed sidebar-unfoldable"
  [class.no-hover-expand]="isNative"
  [visible]="true"
  [unfoldable]="true"
  colorScheme="dark"
>
  <c-sidebar-brand
    [brandFull]="{
      src: 'assets/img/brand/SAGEL_LOGO.svg',
      width: 158,
      height: 46,
      alt: 'Sagel Logo'
    }"
    [brandNarrow]="{
      src: 'assets/img/brand/SAGEL_SMALL.svg',
      width: 46,
      height: 46,
      alt: 'Sagel Logo'
    }"
    routerLink="./dashboard"
  />
  <ng-scrollbar orientation="vertical">
    <c-sidebar-nav [navItems]="navItems" dropdownMode="close" />
  </ng-scrollbar>
  @if (!sidebar.narrow) {
  <button type="button" cSidebarToggler="sidebar" toggle="unfoldable"></button>
  }
</c-sidebar>
}

<!--main-->
<div
  class="wrapper d-flex flex-column min-vh-100 bg-gradient-main dark:bg-transparent"
>
  <!--app-header-->
  <app-default-header
    class="mb-4 d-print-none header header-sticky"
    position="sticky"
    sidebarId="sidebar"
    [isMobile]="isMobile"
    [channelUnread]="channelUnreadTotal"
    (mobileNavRequested)="toggleMobileNav()"
  />
  <!--app-body-->
  <div class="body flex-grow-1 px-3">
    <router-outlet />
  </div>
  <!--app footer-->
  <app-default-footer />
</div>

@if (isMobile) {
<app-mobile-nav
  [items]="navItems"
  [accountItems]="mobileAccountItems"
  [languageItems]="languageOptions"
  [currentLanguage]="currentLanguage"
  [notificationCount]="globalUser.user.new_notifications"
  [notificationsRoute]="'/pages/notifications'"
  [hiddenUrls]="mobileHiddenNavUrls"
  [visible]="mobileNavOpen"
  (close)="closeMobileNav()"
  (actionRequested)="handleMobileNavAction($event)"
  (languageSelected)="changeLanguage($event)"
></app-mobile-nav>
}

<c-modal
  appNativeBack
  backdrop="static"
  [keyboard]="false"
  [visible]="releaseNewsVisible"
  (visibleChange)="$event ? null : dismissReleaseNews()"
  alignment="center"
  size="lg"
>
  <c-modal-header>
    <div class="release-popup__heading">
      <span class="release-popup__eyebrow">{{
        activeRelease?.language === "tr"
          ? "Ürün güncellemesi"
          : "Product update"
      }}</span>
      <h2 cModalTitle>{{ activeRelease?.subject }}</h2>
      <span class="release-popup__version">v{{ activeRelease?.version }}</span>
    </div>
  </c-modal-header>
  @if (activeRelease; as release) {
  <c-modal-body>
    <p class="release-popup__intro">{{ release.content.introduction }}</p>
    @if (release.content.highlights?.length) {
    <section>
      <h3>{{ release.language === "tr" ? "Yenilikler" : "What’s new" }}</h3>
      @for (item of release.content.highlights; track item) {
      <div class="release-popup__item">
        <strong>{{ item.title }}</strong>
        <p>{{ item.description }}</p>
      </div>
      }
    </section>
    } @if (release.content.fixes?.length) {
    <section>
      <h3>{{ release.language === "tr" ? "Düzeltmeler" : "Fixes" }}</h3>
      @for (item of release.content.fixes; track item) {
      <div class="release-popup__item release-popup__item--fix">
        <strong>{{ item.title }}</strong>
        <p>{{ item.description }}</p>
      </div>
      }
    </section>
    } @if (release.content.call_to_action) {
    <p class="release-popup__cta">{{ release.content.call_to_action }}</p>
    } @if (unseenReleases.length > 1) {
    <p class="release-popup__more">
      {{
        release.language === "tr"
          ? "Sürüm geçmişinde " +
            (unseenReleases.length - 1) +
            " güncelleme daha var."
          : "There " +
            (unseenReleases.length - 1 === 1 ? "is" : "are") +
            " " +
            (unseenReleases.length - 1) +
            " more update" +
            (unseenReleases.length - 1 === 1 ? "" : "s") +
            " in the release log."
      }}
    </p>
    }
  </c-modal-body>
  }
  <c-modal-footer>
    <button cButton color="light" (click)="dismissReleaseNews()">
      {{ activeRelease?.language === "tr" ? "Kapat" : "Close" }}
    </button>
    <button cButton color="primary" (click)="openReleaseHistory()">
      {{
        activeRelease?.language === "tr"
          ? "Tüm sürümleri görüntüle"
          : "View all releases"
      }}
    </button>
  </c-modal-footer>
</c-modal>
